module.exports = __webpack_public_path__ + "static/img/100825.189e4d84.png";